"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeBase = void 0;
class NodeBase {
}
exports.NodeBase = NodeBase;
